/**
 * TanStack Query hooks for `auto-debit-billing-stripe-card-on-file-for-platform-fees`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createAutoDebit,
	listAutoDebits,
	autoDebitQueryKeys,
	type CreateAutoDebitBody,
	type CreateAutoDebitResponse,
	type ListAutoDebitResponse,
} from "./api";

export function useAutoDebitsList(): UseQueryResult<ListAutoDebitResponse, Error> {
	return useQuery({
		queryKey: autoDebitQueryKeys.list(),
		queryFn: listAutoDebits,
	});
}

export function useAutoDebitCreate(): UseMutationResult<
	CreateAutoDebitResponse,
	Error,
	CreateAutoDebitBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createAutoDebit,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: autoDebitQueryKeys.all });
		},
	});
}
